import React from "react"

import StringsContext from "./strings-context"

// eslint-disable-next-line react/display-name
const withStrings = WrappedComponent => props => (
  <StringsContext.Consumer>
    {(strings) => (
      <WrappedComponent strings={strings} {...props}>
        {props.children}
      </WrappedComponent>
    )}
  </StringsContext.Consumer>
);

export default withStrings;
